import { render, staticRenderFns } from "./SpecialPricePoolManage.vue?vue&type=template&id=872ccd9a&scoped=true&lang=pug&"
import script from "./SpecialPricePoolManage.vue?vue&type=script&lang=ts&"
export * from "./SpecialPricePoolManage.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialPricePoolManage.vue?vue&type=style&index=0&id=872ccd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872ccd9a",
  null
  
)

export default component.exports